// index.ts

import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Page/HomeView.vue'
import { dataLoaded } from '@/event/dataLoaded'
import { linkGoOrder } from '@/event/basket/linkGoOrder'
import { isOtherThemeHappy, isThemeHappy } from '@/event/theme/theme'
import { isAuthenticated } from '@/event/account/auth/authentification'



const routes = [
  {
    path: '/:table?',
    name: 'racine',
    component: HomeView
  },
  {
    path: '/cproduct/:category_id/:category_name',
    name: 'catalog-product',
    component: () => import('@/views/Page/CatalogProductView.vue')
  },
  { path: '/product/:category_id/:product_id', name: 'product', component: () => import('@/views/Page/ProductView.vue') },
  { path: '/basket', name: 'basket', component: () => import('@/views/Page/BasketView.vue') },
  { path: '/error_urlchecker', name: 'error_urlchecker', component: () => import('@/views/error/ErrorLoadUrl.vue') },
  { path: '/login', name: 'login', component: () => import('@/views/Page/account/LoginView.vue') },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Page/account/RegisterView.vue')
  },
  {
    path: '/confirm-register/:token',
    name: 'confirm-register',
    component: () => import('@/views/Page/account/ConfirmRegisterView.vue')
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import('@/views/Page/account/ForgotView.vue')
  },
  {
    path: '/forget/:token',
    name: 'forget',
    component: () => import('@/views/Page/account/ForgetView.vue')
  },
  { path: '/dashboard', name: 'dashboard', component: () => import('@/views/Page/dashboard/DashboardView.vue') },
  {
    path: '/dashboard/edit',
    name: 'dashboard-edit',
    component: () => import('@/views/Page/dashboard/DashboardEditView.vue')
  },
  {
    path: '/dashboard/password',
    name: 'dashboard-password',
    component: () => import('@/views/Page/dashboard/DashboardPasswordView.vue')
  },
  {
    path: '/dashboard/address',
    name: 'dashboard-address',
    component: () => import('@/views/Page/dashboard/DashboardAddressView.vue')
  },
  { path: '/dashboard/order', name: 'dashboard-order', component: () => import('@/views/Page/dashboard/DashboardOrderView.vue') },
  {
    path: '/dashboard/transaction',
    name: 'dashboard-transaction',
    component: () => import('@/views/Page/dashboard/DashboardTransactionView.vue')
  },
  {
    path: '/dashboard/recurring',
    name: 'dashboard-recurring',
    component: () => import('@/views/Page/dashboard/DashboardRecurringView.vue')
  },
  { path: '/basket/order', name: 'basket-order', component: () => import('@/views/Page/OrderView.vue') },
  {
    path: '/success-payment/:order_id',
    name: 'success-payment',
    component: () => import('@/views/Page/order/SuccessView.vue')
  },
  {
    path: '/cancel-payment/:order_id',
    name: 'cancel-payment',
    component: () => import('@/views/Page/order/CancelView.vue')
  },
  {
    path: '/cancel-delete/:customer_id',
    name: 'cancel-delete',
    component: () => import('@/views/Page/CancelDeletedView.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/Page/information/PrivacyPolicyView.vue')
  },
  {
    path: '/condition-use',
    name: 'condition-use',
    component: () => import('@/views/Page/information/ConditionUseView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: () => '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

const blocked = new Set([
  'basket',
  'dashboard-order',
  'dashboard-transaction',
  'dashboard-recurring',
  'dashboard-password',
  'dashboard-address',
  'dashboard-edit',
  'product',
])



router.beforeEach((to, from, next) => {
  if (from.name == 'basket' && to.name == 'login') {
    linkGoOrder.value = true
  }

  if (dataLoaded.value == undefined && to.name === 'error_urlchecker') {
    return next({ path: '/' })
  }

  const needsAuth = blocked.has(String(to.name)) || to.name === 'basket-order' || to.name === 'dashboard'
  if (!isAuthenticated.value && needsAuth) {
    return next({ path: '/' })
  }

  if (isThemeHappy.value || isOtherThemeHappy.value) {
    if (blocked.has(String(to.name))) {
      return next({ path: '/' })
    }
  }

  next()
})

export default router